import { usePersistentCallback } from '@prophecy/utils/react/hooks';
import { useEffect, useRef } from 'react';
import { ARIA_ACTIVE_DESCENDANT, SELECT_LIST_ID_SEPARATOR } from '../Select/tokens';
export function useActiveOption(containerRef, options, cleanValue, onActiveOptionChange) {
    const optionsRef = useRef(options);
    optionsRef.current = options;
    const cleanValueRef = useRef(cleanValue);
    cleanValueRef.current = cleanValue;
    const handleChange = usePersistentCallback((id)=>{
        if (!id) {
            onActiveOptionChange?.(undefined);
            return;
        }
        const index = Number(id.split(SELECT_LIST_ID_SEPARATOR).pop());
        const currentOptions = optionsRef.current;
        if (!isNaN(index) && index >= 0 && index < currentOptions.length) {
            onActiveOptionChange?.(cleanValueRef.current(currentOptions[index]));
        } else {
            onActiveOptionChange?.(undefined);
        }
    });
    useEffect(()=>{
        const input = containerRef.current?.querySelector('input');
        if (!input) return;
        const rafId = requestAnimationFrame(()=>{
            handleChange(input.getAttribute(ARIA_ACTIVE_DESCENDANT));
        });
        return ()=>cancelAnimationFrame(rafId);
    }, [
        options,
        containerRef,
        handleChange
    ]);
    useEffect(()=>{
        const input = containerRef.current?.querySelector('input');
        if (!input) return;
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations){
                if (mutation.attributeName === ARIA_ACTIVE_DESCENDANT) {
                    handleChange(mutation.target.getAttribute(ARIA_ACTIVE_DESCENDANT));
                }
            }
        });
        observer.observe(input, {
            attributes: true,
            attributeFilter: [
                ARIA_ACTIVE_DESCENDANT
            ]
        });
        return ()=>observer.disconnect();
    }, [
        containerRef,
        handleChange
    ]);
}
